console.log('js/policy.js -> v0.1.0');

$(function() {

    if($('#privacy_modal_trigger').length){
		var el = document.getElementById('privacy_modal_trigger');
		if(el){while ((el = el.parentElement) && !el.classList.contains('modal'));};
		if(el != null){
			$('#privacy_modal_trigger').attr('data-toggle','none');
			$('#privacy_modal_trigger').attr('target','_blank');
			$('#privacy_modal_trigger').attr('href','/terms-and-privacy/'+$('#privacy_modal_trigger').attr('href'));
		};
		if(window.location.href.indexOf('#privacy_modal') > -1){
			setTimeout(function(){
				$('#privacy_modal').modal();
			},600);
		};
	};

	if(window.location.hash == '#privacy_modal') {
		$('#privacy_modal').modal('show');	
	}
});
